import { RESTSerializer } from '@warp-drive/legacy/serializer/rest';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return super.payloadKeyFromModelName(modelName).replace(/^schools\//, '');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey('schools/' + key);
  }
}
